import React, { useEffect, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, PieChart, Pie, Cell } from 'recharts';
import './instructorPerformance.scss';

import { getCoursesTaughtByInstructorId } from '../../services/courseService';
// Sample data (replace with actual data)
const courseData = [
  { course: 'Math', count: 15 },
  { course: 'Science', count: 10 },
  { course: 'Literature', count: 8 },
  { course: 'History', count: 12 },
];

const gradeData = [
  { grade: 'A', count: 8 },
  { grade: 'B', count: 5 },
  { grade: 'C', count: 3 },
];

const vivaData = [
  { name: 'Completed', value: 12 },
  { name: 'Pending', value: 3 },
];

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const InstructorPerformance = ({instructorId}) => {
  const [courseData, setCourseData] = useState([]);
    const fetchCoursesCount = async (id) => {
        try {
            const data = await getCoursesTaughtByInstructorId(id);
           // console.log(data);
            setCourseData(data.data);
        } catch (err) {
        } 
    };
    const truncateText = (text, maxLength) => {
      if (text.length > maxLength) {
        return `${text.substring(0, maxLength)}...`;
      }
      return text;
    };
    const formatTick = (tick) => {
      // Show tick only if it's an integer
      return Number.isInteger(tick) ? tick : '';
    };
    useEffect(() => {      

      fetchCoursesCount(instructorId);
    }, []);
  return (
    <div className="dashboard-container">
      {/* First row */}
      <div className="row">
        {/* First div (top left) */}
        <div className="chart-container">
          <h3>Courses Taught</h3>
          
          <BarChart width={400} height={300} data={courseData} layout="vertical" >
            <CartesianGrid strokeDasharray="3 3" />
            <YAxis type="category" dataKey="course_name" tickFormatter={(value) => truncateText(value, 15)} 
                tick={{ fontSize: '12px' }} 
                width={100}/>
            <XAxis type="number"  tick={{ fontSize: 12 }}
            tickFormatter={formatTick} // Use the formatTick function to filter ticks
            allowDecimals={false}/>
            <Tooltip />
            <Legend />
            <Bar  dataKey="course_count" fill="#8884d8" name="Times Taught" />
          </BarChart>
        </div>
        
        {/* Second div (top right) */}
        <div className="chart-container">
          <h3>Grades Given</h3>
          <PieChart width={300} height={300}>
            <Pie data={gradeData} dataKey="count" nameKey="grade" cx="50%" cy="50%" outerRadius={80} fill="#8884d8" label>
              {
                gradeData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))
              }
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </div>
      </div>
      
      {/* Second row */}
      <div className="row">
        {/* Third div (bottom left) */}
        <div className="circle-container">
          <h3>Vivas Taken</h3>
          <div className="circle">
            <div className="circle-inner">
              <PieChart width={200} height={200}>
                <Pie data={vivaData} dataKey="value" nameKey="name" cx="50%" cy="50%" innerRadius={60} outerRadius={80} fill="#8884d8" label>
                  {
                    vivaData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))
                  }
                </Pie>
              </PieChart>
            </div>
          </div>
        </div>
        
        {/* Fourth div (bottom right) */}
        <div className="placeholder">
          {/* Placeholder for the fourth div */}
        </div>
      </div>
    </div>
  );
};

export default InstructorPerformance;